import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { AppStoreContext } from '../../context/appStoreContext';
import SideNav from '../LandingPage/SideNav';
import LandingPage from '../LandingPage';
import UserSettingsPage from '../UserSettingsPage';
import NotFound from '../../containers/NotFound';
import SessionAuthWrapper from '../../components/SessionAuthWrapper';
import UnauthorizedPage from '../../containers/UnauthorizedPage';
import ComplexEmailDesign from '../ComplexEmailDesign';
import GlobalVariablesPage from '../GlobalVariablesPage';
import EmailAudit from '../EmailAudit';
import MailRoom from '../MailRoom';
import HybridMailRoom from '../HybridMailRoom';
import TemplateSection from '../TemplateSection';
import { isFeatureEnabled, ENABLE_EMAIL_DESIGNS, ENTERPRISE_ENV } from '../../utils/helper';
import ShortMessageDesign from '../../components/ShortMessage';
import ComplexDocumentDesign from '../ComplexDocumentDesign';
import DocumentDashboard from '../Dashboard/DocumentDashboard';
import ComplexEmailDashboard from '../Dashboard/ComplexEmailDashboard';
import ShortMessageDashboard from '../Dashboard/ShortMessageDashboard';
import ZohoDeskSupport from '../ZohoDeskSupport';
import PlanUsage from '../PlansUsage';
import IntegrationKey from '../IntegrationKey';
import Authentication from '../Authentication/index';
import EmailVerificationSuccess from '../EmailVerificationSuccess';
import EmailVerificationPage from '../EmailVerificationPage';
import GeneratedDocuments from '../GeneratedDocuments';
import PDSSupportWidget from '../PDSSupportWidget';
import Enterprise from '../Authentication/Enterprise'
import AlertNotification from '../LandingPage/AlertNotification';
import LicenseExpiredPage from '../Authentication/LicenseExpiredPage';
import EmailTemplateSection from '../EmailTemplateSection';
import ComplexEmailTransactions from '../ComplexEmailTransactions';
import DKVImport from '../DKVImport';
import DKVReusableImport from '../ComplexDocumentDesign/DKVReusableImport';
import { AZURE_DEPLOYMENT } from '../../utils/helper';
import Joyride from 'react-joyride';
import { AppTourContext } from '../../context/appTourContext';
import StatusMonitoring from '../Dashboard/StatusMonitoring/StatusMonitoring';
import EmailViewer from '../Dashboard/StatusMonitoring/EmailViewer.js';
import InteractiveDocumentDesign from '../InteractiveDocumentDesign';
import InteractiveTemplateSection from '../InteractiveTemplateSection';
import { EmbedPage } from '../../embed';
import AccessInterruptedModal from '../../components/SessionAuthWrapper/AccessInterruptedModal';
import { isInIframe } from '../../utils/embedHelper';
import SaasIntegrationKey from '../IntegrationKey/SaasIntegrationKey';
import OpenDesign from '../ComplexDocumentDesign/OpenDesign';
import CommunicationGenerator from '../TemplateSection/CommunicationGenerator';
import HybridMail from '../HybridMail';
import ManageOrganizations from '../ManageOrganizations/';
import NewTemplateSection from '../NewTemplateSection';
import BusinessContracts from '../BusinessContracts';
import XMLBlockImportPage from '../XMLBlockImportPage';
import XMLDocumentImportPage from '../XMLDocumentImportPage';
import BulkDocumentImportPage from '../BulkDocumentImportPage';
import BulkDocumentExportPage from '../BulkDocumentExportPage';
import SessionRedirect from '../SessionRedirect';
import NewEmailTemplateSection from '../NewEmailTemplateSection/index.js';

class Layout extends Component {
  constructor() {
    super();
    this.state = {
      currentUrl: window.location.href,
      nonce: window.location.href,
    };
  }
  async componentDidMount() {
    this.context.updateSessionExists();
  }
  componentDidUpdate() {
    this.context.updateSessionExists();
    if (this.state.currentUrl === window.location.href) {
      this.state.nonce = this.state.currentUrl;
    } else {
      this.state.currentUrl = window.location.href;
      this.state.nonce = window.location.href;
    }
  }
  componentWillUnmount() {
    this.context.updateSessionExists();
  }

  appTourWrapper = (Component, props) => {
    return <AppTourContext.Consumer>
      { tourContext => <Component tourContext={tourContext} { ...props } /> }
    </AppTourContext.Consumer>
  };

  ProtectedRoutes = ({ component: Component, hidePageOnReauth, visible = false, isEmbedded = false, ...rest }) => (
    <SessionAuthWrapper doRedirection={true} requireAuth={true} visible={visible} isEmbedded={isEmbedded} path={rest.path}>
      <Route
        {...rest}
        render={props => (props.hidePageOnReauth ? 
          this.appTourWrapper(LandingPage, props)
          : Component === LandingPage ?
            this.appTourWrapper(LandingPage, props)
            : <Component {...props} />)}
      />
    </SessionAuthWrapper>
  );

  render() {
    const { pathname } = this.props.location;
    const {
      loginVisible,
      emailVerificationVisible,
      ChekOutVerification,
      onboardingStatus,
      checkUserAccessRoles,
      sessionExist,
      isEnterprise,
      userDetails,  
      isLicenseExpired,
      sessionExpired,
      reAuthenticate,
      ssoSetup,
    } = this.context;
    // TODO : Re-enable loader after docstudio APIs are authenticated
    /*if (this.context.hasSession && !this.context.loginVisible && licenseDetails === null) {
      return <Loader />;
    }*/

    return (
      <React.Fragment>    
        {(sessionExpired || reAuthenticate) && <AccessInterruptedModal/>}
        {ENTERPRISE_ENV && isLicenseExpired && <LicenseExpiredPage />}
        {!pathname.startsWith('/design') &&
          !pathname.startsWith('/flow') &&
          !pathname.startsWith('/block') &&
          !pathname.startsWith('/emailDesign') &&
          !pathname.startsWith('/elementDesign') &&
          !pathname.startsWith('/complexEmailDesign') &&
          !pathname.startsWith('/complexEmailBlock') &&
          !pathname.startsWith('/emailElementDesign') &&
          !pathname.startsWith('/shortMessageDesign') &&         
          !pathname.startsWith('/emailSuccess') &&
          !pathname.startsWith('/interactiveDesign') &&
          !pathname.startsWith('/openDesign') &&
          !pathname.startsWith('/hybridDesign') &&
          !pathname.startsWith('/dkv') &&
          (AZURE_DEPLOYMENT ? true : !pathname.startsWith('/auth')) &&
          !pathname.startsWith((AZURE_DEPLOYMENT ? '' : '/auth') + '/reset-password') &&
          onboardingStatus && <SideNav />}
        {sessionExist && <PDSSupportWidget nonce={this.state.nonce} />}
        {loginVisible && (ENTERPRISE_ENV ? <Enterprise /> : <Authentication visiblePage={window.location.pathname.toLowerCase() === '/signup' ? "register" : "login"} />)}
        {emailVerificationVisible && <EmailVerificationPage />}
        {ChekOutVerification && <EmailVerificationSuccess />}
        {!loginVisible && (userDetails.isStorageFull || userDetails.isTransactionFull || userDetails.isEmailTransactionFull) && <AlertNotification />}

        <Switch>
          <Route exact path={`${AZURE_DEPLOYMENT ? '' : '/auth'}/verify-email`} component={EmailVerificationSuccess} />
          <Route
            path={`${AZURE_DEPLOYMENT ? '' : '/auth'}/reset-password`}
            render={props => <Authentication {...props} visiblePage="forgotPassword" />}
          />
          <Route
            path={'/sso'}
            exact
            render={props => {
              if (ENTERPRISE_ENV) {
                return <Enterprise ssoRedirect={true} />
              } else {
                return <div />
              }
            }}
          />
          <Route
            path={'/:tenant/sso'}
            exact
            render={props => {
              if (ENTERPRISE_ENV) {
                return <Enterprise ssoRedirect={true} />
              } else {
                return <div />
              }
            }}
          />
          <Route
            path={'/embed-sso'}
            exact
            render={props => {
              if (ENTERPRISE_ENV) {
                return <Enterprise embedRedirect={true} />
              } else {
                return <div />
              }
            }}
          />   
          <this.ProtectedRoutes
            path={'/openDesign/:documentId'}
            component={OpenDesign}
            isEmbedded={true}
          />
         
          <this.ProtectedRoutes exact path='/embed' isEmbedded={isInIframe} component={EmbedPage}/>

          <this.ProtectedRoutes exact path="/signup" hidePageOnReauth={false} visible={false} />
          <this.ProtectedRoutes exact path="/ldap" hidePageOnReauth={false} visible={false} />
          <this.ProtectedRoutes
            exact
            path="/redirect"
            render={props => {
              if (ENTERPRISE_ENV) {
                return <Authentication {...props} visiblePage={"redirect"} />
              } else {
                return <div />
              }
            }}
          />
          <Route
            exact
            path="/session/redirect"
            component={SessionRedirect}
          />
          <this.ProtectedRoutes
            exact
            path="/"
            component={LandingPage}
            hidePageOnReauth={false}
            visible={false}
          />

          <this.ProtectedRoutes
            exact
            path="/user/account-settings"
            component={
               isFeatureEnabled('Admin Configurations', userDetails) && checkUserAccessRoles(['ADMIN', 'MAILROOMADMIN'])
                ? UserSettingsPage
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/xml-block-import"
            component={
              checkUserAccessRoles(['ADMIN', 'PUBLISHER'])
                ? XMLBlockImportPage
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/xml-document-import"
            component={
              checkUserAccessRoles(['ADMIN', 'PUBLISHER'])
                ? XMLDocumentImportPage
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/bulk-document-import"
            component={
              checkUserAccessRoles(['ADMIN', 'PUBLISHER'])
                ? BulkDocumentImportPage
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/bulk-document-export"
            component={
              checkUserAccessRoles(['ADMIN', 'PUBLISHER'])
                ? BulkDocumentExportPage
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/shortMessageTemplates"
            component={
              isFeatureEnabled('Design System', userDetails) && isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? TemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/complexEmailTemplates"
            component={
              isFeatureEnabled('Design System', userDetails) && ENABLE_EMAIL_DESIGNS && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
              ? NewEmailTemplateSection
              : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/documentTemplates"
            component={
               isFeatureEnabled('Design System', userDetails) && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
                ? NewTemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          {/* <this.ProtectedRoutes
            exact
            path="/publishedTemplates"
            component={
              isFeatureEnabled('Transactions', userDetails) && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? TemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          /> */}
          {/* <this.ProtectedRoutes
            exact
            path="/generateForms"
            component={
              isFeatureEnabled('Transactions', userDetails) && ENTERPRISE_ENV && checkUserAccessRoles(['FORMUSER'])
                ? CommunicationGenerator
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          /> */}
          <this.ProtectedRoutes
            exact
            path="/interactiveTemplates"
            component={
               isFeatureEnabled('Design System', userDetails) && ENTERPRISE_ENV && checkUserAccessRoles(['EDITOR'])
                ? InteractiveTemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          {/* <this.ProtectedRoutes
            exact
            path="/complexEmailPublishedTemplates"
            component={
              isFeatureEnabled('Transactions', userDetails) && ENABLE_EMAIL_DESIGNS && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? ComplexEmailTransactions
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          /> */}
          <this.ProtectedRoutes
            exact
            path="/publishedMessages"
            component={
              isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? TemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/publishedCallMessages"
            component={
              isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? TemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/publishedSMS"
            component={
              isFeatureEnabled('Transactions', userDetails) && isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? TemplateSection
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/mailRoom"
            component={
              isFeatureEnabled('Mail Room', userDetails) && isEnterprise && checkUserAccessRoles(['MAILROOMADMIN', 'MAILROOMCLIENT'])
                ? MailRoom
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          {/* <this.ProtectedRoutes
            exact
            path="/hybridMail"
            component={
              (isFeatureEnabled('Hybrid Mail Room', userDetails) && isEnterprise && checkUserAccessRoles(['HYBRID'])) ? HybridMail : UnauthorizedPage
            }
            hidePageOnReauth={true}
          /> */}
          <this.ProtectedRoutes
            exact
            path="/shortMessageDesign/:templateId"
            component={
              isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? ShortMessageDesign
                : UnauthorizedPage
            }
            hidePageOnReauth={this.lastInteractionTime - this.appMountTime < 30000}
          />
          <this.ProtectedRoutes
            exact
            path="/design/:documentId"
            component={
               checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? ComplexDocumentDesign
                : UnauthorizedPage
            }
          />
            <this.ProtectedRoutes
            exact
            path="/flow/:flowId"
            component={
              checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
                ? ComplexDocumentDesign
                : UnauthorizedPage
            }
          />
            <this.ProtectedRoutes
            exact
            path="/block/:blockId"
            component={
              checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
                ? ComplexDocumentDesign
                : UnauthorizedPage
            }
          />
          <this.ProtectedRoutes
            exact
            path={'/manageVariables'}
            component={
              isFeatureEnabled('Manage Business Data', userDetails) && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
                ? GlobalVariablesPage
                : NotFound
            }
          />
          <this.ProtectedRoutes
            exact
            path={'/generatedDocuments'}
            component={isFeatureEnabled('Cleanup Storage', userDetails) && checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER']) ? GeneratedDocuments : UnauthorizedPage}
          />
          <this.ProtectedRoutes
            exact
            path="/complexEmailDesign/:templateId"
            component={
              ENABLE_EMAIL_DESIGNS && checkUserAccessRoles(['DESIGNER', 'PUBLISHER'])
                ? ComplexEmailDesign
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/complexEmailBlock/:blockId"
            component={
              ENABLE_EMAIL_DESIGNS && checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER'])
                ? ComplexEmailDesign
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/interactiveDesign/:documentId"
            component={
               ENTERPRISE_ENV && checkUserAccessRoles(['EDITOR'])
                ? InteractiveDocumentDesign
                : UnauthorizedPage
            }
          />
          <this.ProtectedRoutes
            exact
            path="/emailAudit"
            component={
              ENABLE_EMAIL_DESIGNS && checkUserAccessRoles(['ADMIN'])
                ? EmailAudit
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/documentDashboard"
            component={isFeatureEnabled('Dashboard', userDetails) ? DocumentDashboard : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/complexEmailDashboard"
            component={ENABLE_EMAIL_DESIGNS && isFeatureEnabled('Dashboard', userDetails) ? ComplexEmailDashboard : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/shortMessageDashboard"
            component={isEnterprise && isFeatureEnabled('Dashboard', userDetails) ? ShortMessageDashboard : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/statusMonitoring"
            component={isFeatureEnabled('Dashboard', userDetails) && checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER', 'JOBMANAGER', 'JOBAPPROVERL1', 'JOBAPPROVERL2', 'JOBAPPROVERL3', 'JOBAPPROVERL4']) ? StatusMonitoring : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/emailViewer/:payloadId"
            component={isFeatureEnabled('Dashboard', userDetails) && checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER', 'JOBMANAGER', 'JOBAPPROVERL1', 'JOBAPPROVERL2', 'JOBAPPROVERL3', 'JOBAPPROVERL4']) ? EmailViewer : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/support"
            component={userDetails?.planMapping?.planName !== 'Free' ? ZohoDeskSupport : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/planUsage"
            component={!isEnterprise ? PlanUsage : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/integrationKey"
            component={isFeatureEnabled('Account Details', userDetails) && checkUserAccessRoles(['ADMIN']) ? ENTERPRISE_ENV ? IntegrationKey : SaasIntegrationKey : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/dkv"
            component={ENTERPRISE_ENV ? DKVImport : UnauthorizedPage}
            hidePageOnReauth={true}
          />
          <this.ProtectedRoutes
            exact
            path="/reusables/import"
            component={ENTERPRISE_ENV ? DKVReusableImport : UnauthorizedPage}
            hidePageOnReauth={true}
          />

          <this.ProtectedRoutes
            exact
            path="/manageOrganizations"
            component={
              isEnterprise && isFeatureEnabled('Organizations', userDetails) && userDetails.userType === 'master' && checkUserAccessRoles(['ADMIN'])
                ? ManageOrganizations
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />

          <this.ProtectedRoutes
            exact
            path="/contracts"
            component={
              isFeatureEnabled('Manage Business Data', userDetails) && checkUserAccessRoles(['ADMIN', 'PUBLISHER'])
                ? BusinessContracts
                : UnauthorizedPage
            }
            hidePageOnReauth={true}
          />

          <Route path={'*'} component={NotFound} />
        </Switch>
        <AppTourContext.Consumer>
          {tourContext => (
          <Joyride
            run={tourContext.runAppTour}
            continuous={true}
            scrollToFirstStep={true}
            steps={tourContext.steps}
            stepIndex={tourContext.stepIndex}
            disableBeacon={true}
            disableOverlayClose={true}
            spotlightClicks={true}
            styles={{
              options: {
                arrowColor: '#000',
                zIndex: 10000,
              },
            }}
            tooltipComponent={tourContext.Tooltip}
          />)}
        </AppTourContext.Consumer>
      </React.Fragment>
    );
  }
}

Layout.contextType = AppStoreContext;

export default withRouter(Layout)
